import cn from "classnames"

import styles from "./SlackMessage.module.scss"

import type { SlackMessageTextProps } from "./SlackMessage.types"

export const SlackMessageText = ({
  text,
  className,
  isLoading
}: SlackMessageTextProps) => (
  <div className={cn(styles.message, className)} aria-busy={isLoading}>
    {text}
  </div>
)
